import { ArtifactType } from '@/services/types/artifact-digest-types';

export const formatBytes = (bytes?: number | null): string | undefined => {
  if (!bytes && bytes !== 0) return undefined;
  const thresh = 1024;
  if (Math.abs(bytes!) < thresh) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let u = -1;
  let value = bytes!;
  do {
    value /= thresh;
    u += 1;
  } while (Math.abs(value) >= thresh && u < units.length - 1);
  return `${value.toFixed(1)} ${units[u]}`;
};

export const formatDate = (iso: string): string => {
  const date = new Date(iso);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;

  return date.toLocaleDateString();
};

export const formatDuration = (duration?: string): string | undefined => {
  if (!duration) return undefined;

  // If already formatted (e.g., "2:34"), return as-is
  if (duration.includes(':')) return duration;

  // If it's a number of seconds, format it
  const seconds = parseInt(duration, 10);
  if (Number.isNaN(seconds)) return duration;

  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const getFileExtension = (filename?: string): string | undefined => {
  if (!filename) return undefined;
  const ext = filename.split('.').pop();
  return ext ? ext.toUpperCase() : undefined;
};

export const getArtifactTypeLabel = (type: ArtifactType): string => {
  switch (type) {
    case ArtifactType.BLOB:
      return 'File';
    case ArtifactType.TRANSCRIPT:
      return 'Transcript';
    case ArtifactType.CONVERSATION:
      return 'Conversation';
    case ArtifactType.STAFF_NOTE:
      return 'Note';
    default:
      return 'Artifact';
  }
};

export const formatArtifactTypeForDisplay = (type: string): string => {
  return type
    .replace('_', ' ')
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());
};
